module.exports = __webpack_public_path__ + "img/btn-lh.707511fd.png";